import { render, staticRenderFns } from "./list-push-me.vue?vue&type=template&id=f85d0396&scoped=true&"
import script from "./list-push-me.vue?vue&type=script&lang=js&"
export * from "./list-push-me.vue?vue&type=script&lang=js&"
import style0 from "./list-push-me.vue?vue&type=style&index=0&id=f85d0396&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d0396",
  null
  
)

export default component.exports